import { render } from "./Tables.vue?vue&type=template&id=14d2924b"
import script from "./Tables.vue?vue&type=script&lang=ts"
export * from "./Tables.vue?vue&type=script&lang=ts"
script.render = render

export default script